import { useState } from 'react';
import { Link } from 'react-router-dom';
import { SvgIcon } from '../SvgIcon';

/** CUBA Notificationbar — dropdown chrome (wired to RCATS notifications later) */
export function Notificationbar() {
  const [open, setOpen] = useState(false);

  return (
    <li className="onhover-dropdown">
      <div className="notification-box" onClick={() => setOpen((v) => !v)} role="button" tabIndex={0}>
        <SvgIcon iconId="notification" />
        <span className="badge rounded-pill badge-secondary">0</span>
      </div>
      <div className={`notification-dropdown onhover-show-div ${open ? 'active' : ''}`}>
        <h6 className="f-18 mb-0 dropdown-title">Notifications</h6>
        <ul>
          <li className="b-l-primary border-4">
            <p>No new alerts yet.</p>
          </li>
          <li>
            <Link className="f-w-700" to="/admin">
              View all
            </Link>
          </li>
        </ul>
      </div>
    </li>
  );
}
